import { formatDate } from '@angular/common'

import { MappableModel } from './mappable-model'

function dateToStr(d: string | null): string {
  if (!d) return '∞'
  return formatDate(d, 'yyyy-MM-dd', 'en-US', 'UTC')
}

export class Tag extends MappableModel {
  public id: string
  public resource_type: string
  public resource_id: string
  public name: string
  public tag_option_id: string
  public tag_option_type: string
  public tag_value_type: string
  public tag_value_id: string
  public tag_value: any
  public boss_organization_id: number
  public description: string
  public properties: any
  public created_at: Date | null
  public updated_at: Date | null

  public get value(): string {
    if (!this.tag_value) return this.name

    switch (this.tag_value_type) {
      case 'date_range':
      case 'Tags::TagDateRangeValue':
        return `${dateToStr(this.tag_value.start_date)} - ${dateToStr(this.tag_value.end_date)}`
      case 'number_range':
      case 'Tags::TagNumberRangeValue':
        return `${this.tag_value.min} - ${this.tag_value.max}`
      default:
        return this.tag_value.value || this.name
    }
  }

  public deserialize(): void {
    this.created_at = this.created_at ? new Date(this.created_at) : null
    this.updated_at = this.updated_at ? new Date(this.updated_at) : null
    // @todo deserialize resource models
  }
}
